import { LOCALES } from 'utils/languageUtils';

/** @type {Readonly<Record<LOCALES.ENGLISH | LOCALES.GREEK, Record<string, string>>>} */
const FOOTER_LABELS = Object.freeze({
  [LOCALES.ENGLISH]: {
    store_label: 'Download the MagentaAPP',
  },
  [LOCALES.GREEK]: {
    store_label: 'Κατέβασε το MagentaAPP',
  },
});
export default FOOTER_LABELS;
